import { showSuccessNotify } from "../../utils/Notiffication";
import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/market/kuper'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });



export default class MarketKuperApi {


    static async getCardsBySearch({ data = { shop: undefined, search: undefined, tab: undefined, providerId: undefined, filters: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/getcards', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async changeCard({ data = { shop: undefined, offer_id: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changecard', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }



    // static async setProviderSku({ data = undefined, ...params }) {
    //     return await fetchService({ url: '/setps', method: 'PATCH', data, ...params })
    // }



    static async updateStocksAndPrices({ data = { shop: undefined, filter: undefined, rules: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/updatestocksandprices', method: 'POST', data, ...params })
    }

    // static async updatePrices({ data = { shop: undefined, filter: undefined, rules: undefined, skladName: undefined }, ...params }) {
    //     return await fetchService({ url: '/updateprices', method: 'POST', data, ...params })
    // }




    static async changeMarginality({ data = { shop: undefined, offer_id: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changemarginality', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async changePrice({ data = { shop: undefined, offer_id: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changeprice', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async changeStock({ data = { shop: undefined, offer_id: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changestock', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async changeStopBrand({ data = { shop: undefined, offerIds: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changestopbrand', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }




    static async updateFeed({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/updatefeedcontent', method: 'POST', data, ...params })
    }

    static async updateFeedStocks({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/updatefeedstocks', method: 'POST', data, ...params })
    }

    static async updateFeedPrices({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/updatefeedprices', method: 'POST', data, ...params })
    }
}